import React, { useRef, useState } from 'react';

interface FileUploadFieldProps {
  id: string;
  accept: string;
  onChange: (file: File | null) => void;
  label: string;
  className?: string;
}

const FileUploadField: React.FC<FileUploadFieldProps> = ({
  id,
  accept,
  onChange,
  label,
  className = '',
}) => {
  const [fileName, setFileName] = useState<string>('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setFileName(file.name);
      onChange(file);
    } else {
      setFileName('');
      onChange(null);
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleClearFile = () => {
    setFileName('');
    onChange(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className={`mb-4 ${className}`}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="flex items-center">
        <input
          type="file"
          id={id}
          accept={accept}
          onChange={handleFileChange}
          ref={fileInputRef}
          className="hidden"
        />
        <div className="relative flex-1">
          <input
            type="text"
            readOnly
            value={fileName}
            placeholder="Nessun file selezionato"
            className="w-full px-3 py-2 border rounded-lg bg-gray-50 cursor-default"
          />
          {fileName && (
            <button
              type="button"
              onClick={handleClearFile}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
          )}
        </div>
        <button
          type="button"
          onClick={handleButtonClick}
          className="ml-2 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Sfoglia
        </button>
      </div>
    </div>
  );
};

export default FileUploadField;
